var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBimobjectLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0H0V22H25V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1426 6.544H12.8814C11.143 6.544 9.37697 6.98894 9.09415 8.62959H9.06589V4.82031H4.86133V17.1959H8.81439V15.277H8.86771C9.31632 16.5838 10.3816 17.39 12.9328 17.39H14.1666C19.4931 17.39 20.1408 15.6103 20.1408 12.9132V11.023C20.1168 8.32543 19.4699 6.544 14.1427 6.544H14.1426ZM16.049 12.578C16.049 13.7461 15.8526 14.4132 13.8343 14.4132H11.3688C9.71511 14.4132 8.81714 14.0519 8.81714 12.4669V11.4399C8.81714 9.85272 9.68607 9.52144 11.3688 9.52144H13.8358C15.8542 9.52144 16.0513 10.1882 16.0513 11.3568L16.049 12.578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBimobjectLogo);
export default __webpack_public_path__ + "static/media/bimobject-logo.eaed00977526e1ec757167e0dd253f4a.svg";
export { ForwardRef as ReactComponent };